import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center px-5 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-12 w-12" />
      <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight">Checkout cancelled.</h1>
      <p className="mt-3 text-muted-foreground">No worries — your card wasn't charged. Your guides are still waiting for you.</p>
      <div className="mt-8 flex gap-3">
        <Link to="/shop"><Button variant="outline" className="rounded-none h-11 border-black/20 px-8">Back to shop</Button></Link>
        <Link to="/bundle"><Button className="rounded-none h-11 bg-primary px-8 text-primary-foreground">View bundle</Button></Link>
      </div>
    </div>
  );
}
